<template>
    <div class="block lg:hidden">
        <div class="relative flex items-center justify-center shadow-md py-2">
            <template v-if="!hideControls">
                <MobileLeftMenu class="absolute top-0 left-0"></MobileLeftMenu>
                <img class="logo-bk" src="../../../../../assets/logo/Logo.svg">
            </template>
            <MobileRightMenu></MobileRightMenu>
        </div>
    </div>
</template>
<script>
import { inject } from 'vue';
import MobileLeftMenu from './MobileLeftMenu.vue';
import MobileRightMenu from './MobileRightMenu.vue';

export default {
    components: {
        MobileLeftMenu,
        MobileRightMenu,
    },
    setup: function () {
        const { hideControls } = inject("SearchBarService")

        return {
            hideControls,
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.topbar-height {
    height: $topbar-height;
}

.logo-bk {
    height: $bk-logo-height;
}
</style>
